export default {
  name: "chevron_down",
  class: "h-5 w-5 text-gray-400 sm:ml-2 sm:-mr-1",
  box: 20,
  svg: `<path
  fill-rule="evenodd"
  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
  clip-rule="evenodd" fill="fillcolor"
/>`,
};
